import * as l from '../../lib/littlejs.esm.js';
import { vec2 } from '../../lib/littlejs.esm.js';
import ldtkData from '../../assets/rex-and-chip.ldtk';
import { loadLevelData } from '../utils/storage.ts';
let levels = [];
let selectedLevelIndex = 0;
function init() {
    levels = ldtkData.levels.filter((l) => l.identifier.startsWith('Rex_')).sort((a, b) => parseInt(a.identifier.split('_')[1]) - parseInt(b.identifier.split('_')[1]));
}
function update() {
    if (l.keyWasPressed('ArrowUp')) {
        selectedLevelIndex = Math.max(0, selectedLevelIndex - 1);
    }
    if (l.keyWasPressed('ArrowDown')) {
        selectedLevelIndex = Math.min(levels.length - 1, selectedLevelIndex + 1);
    }
    if (l.keyWasPressed('Enter') || l.keyWasPressed(' ')) {
        return { levelIndex: selectedLevelIndex };
    }
    return 'none';
}
function render() {
    l.drawTextScreen('Rex and Chip', vec2(l.mainCanvasSize.x / 2, l.mainCanvasSize.y / 2 - 200), 32);
    levels.forEach((level, index) => {
        const levelName = level.identifier.replace('Rex_', 'Level ');
        const levelData = loadLevelData(index);
        let status = 'Not Completed';
        let bestTime = '';
        if (levelData) {
            status = levelData.completed ? 'Completed' : 'Not Completed';
            if (levelData.bestTime) {
                console.log('levelData.bestTime', levelData.bestTime);
                const time = Math.floor(levelData.bestTime / 10) / 100;
                bestTime = ` - Best: ${time}s`;
            }
        }
        const text = `${levelName}: ${status}${bestTime}`;
        const color = index === selectedLevelIndex ? l.YELLOW : l.WHITE;
        l.drawTextScreen(text, vec2(l.mainCanvasSize.x / 2, l.mainCanvasSize.y / 2 - 100 + index * 30), 16, color);
    });
    l.drawTextScreen('Use arrows to select level, Enter to start', vec2(l.mainCanvasSize.x / 2, l.mainCanvasSize.y / 2 + 100), 12);
}
function updatePost() { }
function renderPost() { }
export { init, update, updatePost, render, renderPost };
